// extracted by mini-css-extract-plugin
export default {"title":"From_title__w06HV","icon":"From_icon__CA-5i","description":"From_description__JqFxZ"};